import React, { useState } from "react";
import {
  Box,
  Card,
  CardMedia,
  Typography,
  IconButton,
  Button,
  Grid,
  List,
  ListItem,
  ListItemText,
  Divider,
  Avatar,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import VisibilityIcon from "@mui/icons-material/Visibility";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import Viewproductcarticon from "../../../Componet/ADDtoCart/Viewproductcarticon";
import {
  GetProductByCategories,
  GetUrlCat,
  useCategoryBasedProduct,
} from "../../../client-api/ApiProducts";
import { SellingProduct } from "../../../client-api/ApiHome";
import { Link } from "react-router-dom";
import { Toastsucess } from "../../../Componet/ReusableComponet/toast/Toast";
import {
  UsergetwishList,
  UserWhishList,
} from "../../../client-api/Apiuserdetails";
import { useDispatch } from "react-redux";
import { usePoPupContext } from "../../../Context/PopupContext";
import { resetProduct } from "../../../redux/cartUiSlice";
import { useAuthContext } from "../../../Context/AuthContext";
import { GetSubcategories } from "../../../client-api/APIcategory";

export default function News3() {
   const [hoveredIndex, setHoveredIndex] = useState(null);
  const [category, setCategory] = useState(263);
  const { data: fitnessIndoorProducts } = useCategoryBasedProduct(category, 8);

  const { data: topsellingproduct } = SellingProduct();
  const dispatch = useDispatch();
  const categorySlug = fitnessIndoorProducts?.[0].product?.category_slug;
  const { urlCat } = GetUrlCat(categorySlug);
  const { datasubcategory } = GetSubcategories();
//  console.log(datasubcategory,"datasubcategoryinnew3");
  const getProgress = (start, end) => {
    return Math.round((100 * (start - end)) / start) + "%";
  };
  const { setopenpopup } = usePoPupContext();
  const changecontent = (curElem) => {
    setopenpopup(curElem);
    dispatch(resetProduct());
  };
  const { user, getuserdata } = useAuthContext();
  const { wishofuser } = UserWhishList(getuserdata);
  const { data: datas } = UsergetwishList(getuserdata);
  const displayedSubcategories =
    datasubcategory?.[2]?.sub_categories?.slice(0, 4) || [];

  const handleApi = async (product_id) => {
    // console.log("product_id", product_id);
    try {
      if (!getuserdata?.token) {
        setopenpopup("login");
        return;
      }
      const isInWishList = datas?.products?.some(
        (el) => el?.product?.product_id === product_id
      );
      if (product_id && !isInWishList) {
        await wishofuser(product_id);
        Toastsucess("Added to wishlist!", "sucess", "light");
      }
    } catch (error) {
      Toastsucess(error.message);
    }
  };


  return (
      <Box
      sx={{
        paddingLeft: "5%",
        paddingRight: "5%",
        paddingTop: "3%",
        paddingBottom: "3%",
      }}
    >
      <Grid container spacing={2} alignItems="stretch">
        <Grid item lg={6} xs={12}  sx={{ height: { xs: "100%", md: "auto" } }}>
          {/* fitness indoor section */}
          <Box
            sx={{
              backgroundColor: "#f9f9f9",
              // p: 2,
              height: "100%",
              minHeight: 520,
            }}
          >
            <Grid
              container            
              alignItems="stretch"
              sx={{ height: "100%" }}
            >
              <Grid item xs={12} md={6} sx={{ height: "100%" }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                  }}
                >
                  <img
                    src={`https://ik.imagekit.io/thmmwwbpc/category/images/${urlCat?.data?.category?.image}`}
                    alt={urlCat?.data?.category?.name}
                    style={{
                      objectFit: "cover",
                      width: "100%",
                      height: "100%",
                    }}
                  />
                </Box>
              </Grid>
              <Grid
                item
                xs={12}
                md={6}
                lg={6}
                sx={{
                  height: "100%",
                  display: "flex",
             
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    marginTop:'auto',
                    marginBottom:'auto',
                    paddingTop: "30px",
                  }}
                >
                  <Typography
                    variant="h2"
                    fontWeight="bold"
                    gutterBottom
                    style={{ fontSize: "2.25rem" ,    fontFamily: "CamptonBook",}}
                  >
                    {urlCat?.data?.category?.name}
                  </Typography>
                  <List disablePadding>
                    {displayedSubcategories.map((item, index) => {
                      return (
                        <React.Fragment key={index}>
                          <ListItem disablePadding>
                            <ListItemText
                              sx={{ textAlign: "center" }}
                              primary={
                                <Link
                                  style={{
                                    textDecoration: "none",
                                    color: "inherit",    fontFamily: "CamptonBook",
                                  }}
                                  to={`/category/${item.slug}`}
                                  state={{
                                    child_category_id: item.id,
                                    banner_image: item.banner_image,
                                  }}
                                >
                                  {item?.name}
                                </Link>
                              }
                            />
                          </ListItem>
                          {index !== displayedSubcategories.length - 1 && (
                            <Divider />
                          )}
                        </React.Fragment>
                      );
                    })}
                  </List>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Grid>

        <Grid item lg={6} xs={12}>
          <Grid container spacing={2}>
            {fitnessIndoorProducts?.slice(0, 4).map((curElem, index) => {
              const isInWishList = datas?.products?.some(
                (el) =>
                  el?.product?.product_id === curElem?.product?.product_id,
              );

              return (
                <Grid item key={index} xs={12} sm={6}>
             
                  <Card
                    onMouseEnter={() => setHoveredIndex(index)}
                    onMouseLeave={() => setHoveredIndex(null)}
                    sx={{
                      height: "100%",
                      borderRadius: 2,
                      overflow: "hidden",
                      position: "relative",
                      transition: "all 0.3s ease-in-out",
                      backgroundColor:
                        hoveredIndex === index ? "#FFA500" : "#ffffff",
                      boxShadow: hoveredIndex === index ? 4 : 1,
                    }}
                  >
                    <Box px={2} pt={2}>
                      <Typography variant="subtitle1" fontWeight="bold" noWrap       sx={{
                          fontFamily: "CamptonBook",
                         
                        }}>
                        {curElem?.product?.name}
                      </Typography>
                    </Box>

                    <CardMedia
                      component="img"
                      height="250"
                      src={`https://ik.imagekit.io/thmmwwbpc/product/images/${curElem?.product?.images?.[0]?.url}`}
                      alt={curElem?.product?.name}
                      sx={{ objectFit: "contain", p: 2 }}
                    />

                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      px={2}
                      pb={2}
                    >
                      <Typography fontWeight="bold">
                        {curElem?.product?.discount_price ? (
                          <>
                            <del>AED {curElem?.product?.unit_price}</del>{" "}
                            <span style={{ color: "red" }}>
                              AED {curElem?.product?.discount_price}
                            </span>
                          </>
                        ) : (
                          <>AED {curElem?.product?.unit_price}</>
                        )}
                      </Typography>
                      <Box
                        sx={{
                          backgroundColor: "#f4f4f4",
                          padding: "8px 12px",
                          borderRadius: "4px",
                        }}
                      >
                        <AddIcon />
                      </Box>
                    </Box>

                    {hoveredIndex === index && (
                      <Box
                        position="absolute"
                        bottom={0}
                        left={0}
                        width="100%"
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        px={2}
                        py={1.5}
                        sx={{
                          backgroundColor: "#0f1111",
                          color: "white",
                      
                        }}
                      >
                        <Viewproductcarticon modalofaddtocart={curElem} />
                        <Box display="flex" gap={1}>
                          <Link
                            to={`/${curElem?.product?.slug}`}
                            state={{
                              product_slug: curElem?.product?.slug,
                              store_id: curElem.store_id,
                            }}
                            className="linkstyle"
                          >
                            <VisibilityIcon
                              sx={{
                                color: "whitesmoke",
                                marginTop: "10px",
                              }}
                            />
                          </Link>
                          <IconButton sx={{ color: "white", }}>
                            <FavoriteBorderIcon
                              onClick={()=>handleApi(curElem?.product?.product_id)}
                              sx={{
                                cursor: "pointer",
                                ...(isInWishList && { color: "red" }),
                              }}
                            />
                          </IconButton>
                        </Box>
                      </Box>
                    )}
                  </Card>
                </Grid>
              );
            })}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}
